import { MyBalloon, MyMessageContainer } from './MyMessageContainer';
import { TextMessage } from '../by-type/TextMessage';
import { FileMessage } from '../by-type/FileMessage';
import React from 'react';
import { Message } from '../../../type';
import { DeletedMessage } from '../by-type/DeletedMessage';
import { ErrorMessage } from '../by-type/ErrorMessage';
import { MyMediaErrorMessage } from './MyMediaErrorMessage';
import { MediaErrorMessageAware } from './MediaErrorMessageAware';

type MyMessageProps = {
  standalone?: boolean;
  message: Message;
};

export const MyMessage = React.forwardRef<HTMLLIElement, MyMessageProps>(
  (props, ref) => {
    const { message } = props;
    const {
      channelGuid,
      guid: messageGuid,
      messageType,
      mediaDeleted,
    } = message;
    const { scanStatus, compressError, fileName, url, thumbnailUrl } = message;

    return (
      <MediaErrorMessageAware
        error={() => (
          <MyMediaErrorMessage key={message.guid} ref={ref} message={message} />
        )}
      >
        <MyMessageContainer
          key={message.guid}
          ref={ref}
          message={message}
          standalone={props.standalone}
        >
          {() => {
            if (mediaDeleted) {
              return (
                <MyBalloon>
                  <DeletedMessage message={message} />
                </MyBalloon>
              );
            } else if (messageType === 'TEXT') {
              return (
                <MyBalloon>
                  <TextMessage
                    content={props.message.content}
                    contentKey={props.message.contentKey}
                    contentParams={props.message.contentParams}
                    color='white'
                    hrefColor='#ACCCF3'
                  />
                </MyBalloon>
              );
            } else {
              const fileMessage = (
                <FileMessage
                  channelGuid={channelGuid}
                  messageGuid={messageGuid}
                  messageType={messageType}
                  local={message.localMessage}
                  url={url}
                  thumbnailUrl={thumbnailUrl}
                  fileName={fileName}
                  scanStatus={scanStatus}
                  color='#ACCCF3'
                />
              );
              if (scanStatus === 'INFECTED') {
                return (
                  <MyBalloon
                    backgroundColor='#ecf2fb'
                    border='solid 0.5px #d00070'
                  >
                    <ErrorMessage
                      messageId='messages.file.infected'
                      sx={{ pl: 2 }}
                    />
                  </MyBalloon>
                );
              } else if (compressError || scanStatus === 'SCAN_ERROR') {
                return (
                  <MyBalloon
                    backgroundColor='#ecf2fb'
                    border='solid 0.5px #d00070'
                  >
                    <ErrorMessage
                      messageId='messages.file.compress-error'
                      sx={{ pl: 2 }}
                    />
                  </MyBalloon>
                );
              } else if (messageType === 'PDF' || messageType === 'WORD') {
                return <MyBalloon>{fileMessage}</MyBalloon>;
              } else {
                return fileMessage;
              }
            }
          }}
        </MyMessageContainer>
      </MediaErrorMessageAware>
    );
  },
);

MyMessage.displayName = 'MyMessage';
